<template>
  <footer class="footer">
    <!-- <span v-if="!openVideo">
      <m-offer-row v-if="!openLogin"/>
    </span> -->

    <div class="footer-social">
      <a
        class="d-flex justify-content-center align-items-center btn-icon"
        href="https://t.me/madya_ir"
        target="_blank"
      >
        <i class="flaticon-telegram icon-22"></i>
      </a>
      <a
        class="d-flex justify-content-center align-items-center btn-icon"
        href="https://www.instagram.com/madya_ir/"
        target="_blank"
      >
        <i class="flaticon-instagram icon-22"></i>
      </a>
      <a
        class="d-flex justify-content-center align-items-center btn-icon"
        href="https://www.linkedin.com/company/madya"
        target="_blank"
      >
        <i class="flaticon-linkedin icon-22"></i>
      </a>
      <a
        href="https://www.aparat.com/madya_ir"
        target="_blank"
        class="d-flex justify-content-center align-items-center btn-icon"
        @mouseover="isShow=false"
        @mouseleave="isShow=true"
      >
        <img src="/static/img/aparat.svg" alt="aparat-madya" v-if="isShow">
        <img src="/static/img/aparat-hover.svg" alt="aparat-madya" v-if="!isShow">
      </a>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-3">
          <div class="footer-box">
            <h4>درباره ما</h4>
            <p>"مادیا" یک پلتفرم آموزشی می باشد که با هدف ارتقای سطح کیفیت زندگی و فضای کسب دانش و کار, از طریق آموزش‌های آنلاین پا به عرصه فعالیت نهاده است. "مادیا" سعی دارد با برطرف نمودن نقاط ضعف سیستم های یادگیری و تدریس مجازی، خدمات منحصر بفردی را به مدرسین و مخاطبین خود ارائه دهد.</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="footer-box">
            <h4>تماس با مادیا</h4>
            <ul>
              <li>
                <p>
                  <i class="flaticon-map"></i>
                  تهران - سعادت آباد - خيابان سرو غربي - ابتداي خيابان بخشايش - پلاك ۳۷ - طبقه اول - واحد۳
                </p>
              </li>

              <li>
                <p>
                  <i class="flaticon-phone-call"></i>
                  021-22094720
                </p>
              </li>

              <li>
                <p>
                  <i class="flaticon-mail"></i>
                  madya.oce@gmail.com
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="footer-box">
            <h4>لینک های مفید</h4>
            <ul>
              <li>
                <router-link to="/v1/teaching" exact>درخواست تدریس</router-link>
              </li>
              <li>
                <a href="https://blog.madya.ir/" target="_blank">وبلاگ</a>
              </li>
              <li>
                <router-link to="/v1/about?tabActive=1" exact>مادیا در رسانه ها</router-link>
              </li>
              <li>
                <router-link to="/v1/about?tabActive=2" exact>تماس با ما</router-link>
              </li>
              <li>
                <router-link to="/v1/terms-of-use" exact>قوانین و مقررات</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="footer-box">
            <h4>عضویت در خبرنامه مادیا</h4>
            <p>با عضویت در خبرنامه مادیا، به محض انتشار آموزش یا تخفیف جدید، از طریق ایمیل باخبر شوید، به این ترتیب هیچ تخفیف و آموزشی را از دست ندهید</p>

            <div class="group-form mod-ltr">
              <input
                name="email"
                v-validate="'required|email'"
                type="text"
                :class="{active:email != '' }"
                v-model="email"
              >
              <span class="bar"></span>
              <label>ایمیل</label>
              <span v-if="errors.has('email')" class="is-danger">ایمیل صحیح را وارد کنید</span>
            </div>
            <button
              @click="postEmail"
              class="mt-1 d-block bttn-fill bttn bttn-primary"
            >عضویت در خبر نامه</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="footer-end">
          <p>کليه حقوق برای سایت</p>
          <a href="http://www.madya.ir/">مادیا</a>
          <p>محفوظ می‌باشد.</p>
          <a href="http://www.madya.ir/">madya.ir</a>
          <p>Copyright © 2018</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import MOfferRow from "~ui/offer-row";

export default {
  components: {
    MOfferRow
  },
  computed: {
    openLogin() {
      return this.$store.state.auth.showLogin;
    },
    openVideo() {
      return this.$store.state.video.show;
    }
  },
  data() {
    return {
      email: "",
      isShow: true
    };
  },
  methods: {
    async postEmail() {
      await this.$store.dispatch("newsLatter", {
        email: this.email,
        group: "10939494"
      });
      this.email = "";
      this.$validator.reset();
    }
  }
};
</script>
<style lang="less" scoped>
@import (reference) "../assets/css/variable.less";

.footer {
  background-color: #282828;
  &-social {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    background-color: #3c8e3f;
    a {
      margin: 5px 7px;
      color: #fff;
      width: 35px;
      height: 35px;
      border-radius: 6px;
      &:hover {
        background-color: #fff;
        color: #282828;
      }
    }
  }
  &-box {
    h4 {
      font-size: 18px;
      color: #f3f3f3;
      position: relative;
      padding: 5px 0;
      margin-bottom: 20px;
      display: inline-block;
      &:before {
        content: "";
        height: 3px;
        background-color: @green;
        left: 0;
        position: absolute;
        right: 0;
        bottom: -7px;
      }
    }
    p {
      font-size: 14px;
      text-align: justify;
      color: #f3f3f3;
    }

    ul {
      display: flex;
      flex-direction: column;
      li {
        margin-bottom: 10px;
      }

      p {
        display: flex;
        align-items: top;
        i {
          margin-left: 10px;
        }
      }
      a {
        display: block;
        color: #f3f3f3;
        transition: all 0.3s ease-in;
        &:hover,
        &.router-link-active {
          color: @green;
        }
      }
    }
  }
  &-end {
    text-align: center;
    width: 100%;
    margin-top: 15px;

    p {
      display: inline-block;
      font-size: 16px;
      text-align: justify;
      position: relative;
      color: #f3f3f3;
      &:before {
        content: "";
        height: 1px;
        background-color: @green;
        left: 0;
        position: absolute;
        right: 0;
        bottom: -7px;
      }
    }
  }
}
.group-form label,
.group-form .is-danger {
  font-size: 12px;
  background: #fff;
  padding: 0 15px;
  border-radius: 5px;
}
.group-form textarea.active ~ label,
.group-form textarea:focus ~ label,
.group-form input.active ~ label,
.group-form input:focus ~ label {
  top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue